import React, { useEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { IntlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { CircularProgress, Box, Grid } from '@material-ui/core';

import {
  getContractTypeSelector,
  getTypeContractInfoSelector,
  getNumPoliceSelector,
  getDateEcheanceSelector,
} from 'store/contract/selectors';
import Header from 'containers/SignupPages/Header';
import messages from 'containers/SignupPages/AuthByContract/messages';
import { translate } from 'helpers/intl';
import Form from 'containers/SignupPages/AuthByContract/Form';

import { getContractType } from 'store/contract/actions';
import { setSignupStep } from 'store/user/actions';
import { getIsLoadingContractSelector } from 'store/contract/selectors';
import { PERSONAL_INFO } from 'containers/SignupPages/constants';
import GaLoadHOC from 'helpers/GATracking/GaLoadHOC';
import { EVENT_CATEGORIES } from 'helpers/GATracking';

export type ContractType = {
  type: string;
  value: string;
};

export type AuthByContractProps = {
  intl: IntlShape;
  isLoading: boolean;
  isLoadingContract: boolean;
  getContractType: Function;
  onSubmitStep: Function;
  contractType: ContractType[];
  setSignupStep: Function;
  typeContractInfos: string;
  numPolice: string;
  dateEcheance?: string;
};

const AuthByContract = (props: AuthByContractProps) => {
  /* eslint-disable */
  useEffect(() => {
    props.getContractType();
  }, []);
  /* eslint-enable */

  return (
    <GaLoadHOC category={EVENT_CATEGORIES.LOGIN_CONTRACT}>
      <React.Fragment>
        <Header
          title={translate({ ...messages.title }, props)}
          subTitle={translate({ ...messages.subTitle }, props)}
        />
        {!props.isLoadingContract && props.contractType.length ? (
          <Form
            isLoading={props.isLoading}
            getContractType={props.getContractType}
            contractType={props.contractType}
            typeContractInfos={props.typeContractInfos}
            numPolice={props.numPolice}
            dateEcheance={props.dateEcheance}
            onClickPrevious={
              /* istanbul ignore next */ () => {
                props.setSignupStep(PERSONAL_INFO);
              }
            }
            onSubmitStep={props.onSubmitStep}
          />
        ) : (
          <Box p={13}>
            <Grid justify="center" alignItems="center" container>
              <CircularProgress data-testid="loader" size={40} />
            </Grid>
          </Box>
        )}
      </React.Fragment>
    </GaLoadHOC>
  );
};

const mapStateToProps = createStructuredSelector<
  any,
  {
    contractType: ContractType[];
    isLoadingContract: boolean;
    typeContractInfos: string;
    numPolice: string;
    dateEcheance: string;
  }
>({
  contractType: getContractTypeSelector,
  isLoadingContract: getIsLoadingContractSelector,
  typeContractInfos: getTypeContractInfoSelector,
  numPolice: getNumPoliceSelector,
  dateEcheance: getDateEcheanceSelector,
});

const mapDispatchToProps = {
  getContractType,
  setSignupStep,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(AuthByContract));
